import { CSSProperties } from 'react'

const styles = {
  container: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  } as CSSProperties,
  textField: {
    width: 'calc(30vw)'
  } as CSSProperties,
  link: {
    cursor: 'pointer',
    underline: 'hover'
  } as CSSProperties
}

export default styles
